export default __webpack_public_path__ + "static/media/svg-6.93bd8e08.svg";